import { MissionDescriptionSkin, SectionStatus, ValidityConditionType } from '@flipster/apis/v1/rewardHub/types';

import { RegularMission } from '../../types';
import { MultipleMissions } from './multiple-missions';
import SingleMission from './single-mission';

interface Props {
  missions: RegularMission[];
  validityConditions: ValidityConditionType[];
  sectionStatus: SectionStatus;
  sectionDescription?: MissionDescriptionSkin;
}

const RegularMissions = ({ missions, validityConditions, sectionStatus, sectionDescription }: Props) => {
  if (missions.length === 1 && missions[0].status && missions[0].spec) {
    return <SingleMission mission={missions[0]} sectionDescription={sectionDescription} />;
  } else if (missions.length > 1) {
    return (
      <MultipleMissions
        missions={missions}
        validityConditions={validityConditions}
        sectionStatus={sectionStatus}
        sectionDescription={sectionDescription}
      />
    );
  }
  return null;
};

export default RegularMissions;
